<template>

  <v-form
    v-model="formdata.valid"
    ref="validatesubform"
    lazy-validation
  >
    <v-layout
      row
      wrap
    >

      <v-flex
        lg6
        sm6
      >
        <v-text-field
          label="Task Name"
          prepend-icon="tune"
          v-model="formdata.title"
          required
          :rules="formdata.requiredfield"
        ></v-text-field>
      </v-flex>
      <v-flex
        lg3
        sm3
      >
        <v-text-field
          label="From"
          v-model="formdata.addedByUser"
          prepend-icon="person"
          required
        ></v-text-field>
      </v-flex>
      <v-flex
        lg3
        sm3
      >

      </v-flex>

      <v-flex
        sm6
        lg6
      >
        <v-autocomplete
          hint="Atleast 3 Characters required"
          :loading="loader"
          flat
          :items="userItems"
          v-model="formdata.onBehalfID"
          label="On Behalf Of"
          chips
          prepend-icon="people"
          item-text="name"
          item-value="userID"
        >
          <template
            slot="selection"
            slot-scope="data"
          >
            <v-chip
              :selected="data.selected"
              close
              class="chip--select-multi"
              @input="removeCC(data.item)"
            >
              <v-avatar
                class="primary white--text"
                v-text="data.item.userName.slice(0, 1).toUpperCase()"
              ></v-avatar>
              {{ data.item.nickName }}
            </v-chip>
          </template>
          <template
            slot="item"
            slot-scope="data"
          >
            <template v-if="typeof data.item !== 'object'">
              <v-list-tile-content v-text="data.item"></v-list-tile-content>
            </template>
            <template v-else>
              <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
              </v-list-tile-content>
            </template>
          </template>
        </v-autocomplete>
      </v-flex>
      <v-flex
        sm3
        lg3
      >

        <v-radio-group
          prepend-icon="verified_user"
          v-model="formdata.followUp"
        >
          <v-radio
            label="Follow up"
            value="true"
          ></v-radio>
          <v-radio
            label="No Follow up"
            value="false"
          ></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex
        sm6
        lg6
      >

        <v-autocomplete
          hint="Atleast 3 Characters required"
          :loading="loader"
          flat
          :items="userGroupItems"
          v-model="formdata.assignedCc"
          label="CC Group"
          chips
          prepend-icon="people"
          item-text="name"
          item-value="userGroupID"
           @change="userGroupCC"
        ></v-autocomplete>
      </v-flex>
      <v-flex
        sm6
        lg6
      >
        <v-autocomplete
          hint="Atleast 3 Characters required"
          :loading="loader"
          :items="userItems"
          v-model="formdata.assignedCC"
          label="CC"
          chips
          multiple
          prepend-icon="person_add"
          item-text="name"
          item-value="userID"
        >
          <template
            slot="selection"
            slot-scope="data"
          >
            <v-chip
              :selected="data.selected"
              close
              class="chip--select-multi"
              @input="removeCC(data.item)"
            >
              <v-avatar
                class="primary white--text"
                v-text="data.item.userName.slice(0, 1).toUpperCase()"
              ></v-avatar>
              {{ data.item.nickName }}
            </v-chip>
          </template>
          <template
            slot="item"
            slot-scope="data"
          >
            <template v-if="typeof data.item !== 'object'">
              <v-list-tile-content v-text="data.item"></v-list-tile-content>
            </template>
            <template v-else>
              <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
              </v-list-tile-content>
            </template>
          </template>
        </v-autocomplete>
      </v-flex>
      <!-- <v-flex
        sm6
        lg6
      >
      </v-flex> -->
      <v-flex
        sm6
        lg6
      >

        <v-autocomplete
           hint="Atleast 3 Characters required"
            :loading="loader"
            flat
            :items="userGroupItems"
            label="Assigned To Group"
            chips
            prepend-icon="people"
            item-text="name"
            item-value="userGroupID"
            @change="userGroupTo"
        >

        </v-autocomplete>
      </v-flex>
      <v-flex
        sm6
        lg6
      >

        <v-autocomplete
          hint="Atleast 3 Characters required"
          :loading="loader"
          flat
          :items="userItems"
          v-model="formdata.assignedTo"
          label="Assigned To"
          chips
          prepend-icon="perm_identity"
          required
          :rules="formdata.requiredfield"
          item-text="name"
          item-value="userID"
          multiple
        >
          <template
            slot="selection"
            slot-scope="data"
          >
            <v-chip
              :selected="data.selected"
              close
              class="chip--select-multi"
              @input="removeTo(data.item)"
            >
              <v-avatar
                class="primary white--text"
                v-text="data.item.userName.slice(0, 1).toUpperCase()"
              ></v-avatar>
              {{ data.item.nickName }}
            </v-chip>
          </template>
          <template
            slot="item"
            slot-scope="data"
          >
            <template v-if="typeof data.item !== 'object'">
              <v-list-tile-content v-text="data.item"></v-list-tile-content>
            </template>
            <template v-else>
              <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
              </v-list-tile-content>
            </template>
          </template>
        </v-autocomplete>
      </v-flex>
      <v-flex
        sm6
        lg6
      >

        <v-menu
          :close-on-content-click="false"
          v-model="menudue"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="formdata.dueDate"
            label="Due Date"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker
            v-model="formdata.dueDate"
            @input="menudue = false"
          ></v-date-picker>
        </v-menu>

      </v-flex>
      <v-flex
        sm3
        lg3
      >
        <v-checkbox
          v-model="formdata.overDueAllowed"
          label="Overdue not allowed"
          value="True"
        ></v-checkbox>
      </v-flex>
      <v-flex
        sm3
        lg3
      >
        <v-checkbox
          v-model="formdata.isUrgent"
          label="Is Urgent"
        ></v-checkbox>
      </v-flex>
      <v-flex
        sm6
        lg6
      >
        <v-autocomplete
          hint="Atleast 3 Characters required"
          :loading="loader"
          flat
          :items="projectItems"
          v-model="formdata.projectID"
          label="Project"
          chips
          prepend-icon="pages"
          required
          item-text="name"
          item-value="projectID"
        >
          <template
            slot="selection"
            slot-scope="data"
          >
            <v-chip
              :selected="data.selected"
              close
              class="chip--select-multi"
              @input="removeProject(data.item)"
            >
              <v-avatar
                class="primary white--text"
                v-text="data.item.name.slice(0, 1).toUpperCase()"
              ></v-avatar>
              {{ data.item.name }}
            </v-chip>
          </template>
          <template
            slot="item"
            slot-scope="data"
          >
            <template v-if="typeof data.item !== 'object'">
              <v-list-tile-content v-text="data.item"></v-list-tile-content>
            </template>
            <template v-else>
              <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
              </v-list-tile-content>
            </template>
          </template>
        </v-autocomplete>
      </v-flex>
      <v-flex
        sm6
        lg6
      >
        <v-autocomplete
          hint="Atleast 3 Characters required"
          :loading="loader"
          flat
          :items="tagItems"
          v-model="formdata.tagIds"
          label="Tag"
          chips
          multiple
          prepend-icon="local_offer"
          item-text="name"
          item-value="tagMasterID"
        >
          <template
            slot="selection"
            slot-scope="data"
          >
            <v-chip
              :selected="data.selected"
              close
              class="chip--select-multi"
              @input="removeTag(data.item)"
            >
              <v-avatar
                class="primary white--text"
                v-text="data.item.name.slice(0, 1).toUpperCase()"
              ></v-avatar>
              {{ data.item.name }}
            </v-chip>
          </template>
          <template
            slot="item"
            slot-scope="data"
          >
            <template v-if="typeof data.item !== 'object'">
              <v-list-tile-content v-text="data.item"></v-list-tile-content>
            </template>
            <template v-else>
              <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
              </v-list-tile-content>
            </template>
          </template>
        </v-autocomplete>
      </v-flex>
      <v-flex
        sm6
        lg6
      >

        <v-combobox
          v-model="formdata.personaltagIds"
          :items="PersonaltagItems"
          label="Personal Tag"
          multiple
          prepend-icon="filter_vintage"
        >
          <template
            slot="selection"
            slot-scope="data"
          >
            <v-chip
              :selected="data.selected"
              close
              class="chip--select-multi"
              @input="removePTag(data.item)"
            >
              <v-avatar
                class="primary white--text"
                v-text="data.item.slice(0, 1).toUpperCase()"
              ></v-avatar>
              {{ data.item }}
            </v-chip>
          </template>
          <template
            slot="item"
            slot-scope="data"
          >
            <template v-if="typeof data.item !== 'object'">
              <v-list-tile-content v-text="data.item"></v-list-tile-content>
            </template>
            <template v-else>
              <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item"></v-list-tile-title>
                <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
              </v-list-tile-content>
            </template>
          </template>
        </v-combobox>

      </v-flex>
      <v-flex
        sm6
        lg6
      >
        <v-autocomplete
          flat
          :items="taskStatus"
          v-model="formdata.statusCodeID"
          label="Status"
          chips
          prepend-icon="beenhere"
          required
          :rules="formdata.requiredfield"
          item-text="status"
          item-value="statusCodeID"
        >
          <template
            slot="selection"
            slot-scope="data"
          >
            <v-chip
              :selected="data.selected"
              close
              class="chip--select-multi"
              @input="removeStatus(data.item)"
            >
              <v-avatar
                class="primary white--text"
                v-text="data.item.status.slice(0, 1).toUpperCase()"
              ></v-avatar>
              {{ data.item.status }}
            </v-chip>
          </template>
          <template
            slot="item"
            slot-scope="data"
          >
            <template v-if="typeof data.item !== 'object'">
              <v-list-tile-content v-text="data.item"></v-list-tile-content>
            </template>
            <template v-else>
              <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.status"></v-list-tile-title>
                <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
              </v-list-tile-content>
            </template>
          </template>
        </v-autocomplete>
      </v-flex>
      <!-- <v-flex
        lg12
        sm12
      >
         
        <p> Main task Description</p>
        <quill-editor
          class="quill"
          :content="maindescription"
          :options="editorOption"
          v-model="maindescription"
          aria-placeholder="Main task Content here..."
        >
        </quill-editor>
        </br></br></br></br>
      </v-flex> -->
      <v-flex
        lg12
        sm12
      >
        <!-- <v-textarea
            prepend-icon="note_add"
            v-model="formdata.description"
            label="Description"
          >
          </v-textarea> -->
        <p> Task Description</p>
        <quill-editor
          class="quill"
          :content="formdata.description"
          :options="editorOption"
          v-model="formdata.description"
          aria-placeholder="Main task Content here..."
        >
        </quill-editor>
        </br></br></br></br>
      </v-flex>
      <v-flex
        sm6
        lg6
      >
        <upload-btn
          ref="refsubtask"
          :fileChangedCallback="filesubChanged"
          title="Upload your file"
          name="uploadsubtask"
          uniqueId
        >
          <template slot="icon-left">
            <v-icon
              left
              color="white"
            >attachment</v-icon>
          </template>
        </upload-btn>
        <div class="large-12 medium-12 small-12 cell">
          <div
            v-for="(file, key) in uploadedFiles"
            class="file-listing"
          >{{ file.name }}
            <v-btn
              icon
              v-if="!showdownloads"
              @click="removeFile( key )"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <v-btn
              icon
              v-if="showdownloads"
              @click="downloadFile( key )"
            >
              <v-icon>save_alt</v-icon>
            </v-btn>
          </div>
        </div>
      </v-flex>

    </v-layout>

  </v-form>

</template>

<script>
import UploadButton from 'vuetify-upload-button';
import Bytes from 'bytes';
import { uploadDocuments, downloadFile, documentUsers } from '@/api/document';
import { getApplicationUsers, getTaskSorting, getUserGroups, getSubTasksbyStatus, getTaskSearchFilter, getTaskAssigne, completeTask, getTaskMasters, getTaskAttachment, getTaskComments, createTaskComments, getSubTasksId, getProjects, getTagMaster, getPersonalTags, getTaskNotes, getTaskMaster, getDataSubTask, createTaskMaster, updateTaskMaster, createTaskNotes, createPersonalTags, updateTaskNotes, createSubTaskMaster, updateSubTaskMaster, deleteTaskMaster, getTaskLinks, getDataTaskLink, createTaskLinks, updateTaskLink, deleteTaskLink,getUserById } from '@/api/taskMaster';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import GlobalMessage from '@/constant'

export default {
  components: {
    'upload-btn': UploadButton,

    quillEditor,

  },

  data: () => ({
    scrollSettings: {
      maxScrollbarLength: 160
    },
    personalTags: [
      'Programming',
      'Design',
      'Vue',
      'Vuetify'
    ],
    search: null,
    taskStatus: [
      { status: 'Draft', statusCodeID: 511 },
      { status: 'Assigned', statusCodeID: 512 },
      { status: 'Cancelled', statusCodeID: 514 }],


    //personalTags: [{ tagId: 1, tag: 'Demo' }],

    editorOption: {

    },
    maindescription: '',
    assignedCC: [],
    onBehalfID: null,
    PersonaltagItems: [],
    menudue: false,
    loader: false,
    size: 'lg',
    view: 'grid',
    folder: false,
    taskfiles: new FormData(),
    showdownloads: false,
    parentTaskID: null,
    mainTaskId: null,
    formdata: {
      valid: false,
      taskID: -1,
      date: new Date(),
      title: '',
      assignedTo: [],
      dueDate: new Date(),
      description: '',
      projectID: null,
      assignedCC: [],
      onBehalfID: null,
      sessionID: '',
      addedByUserID: 1,
      addedDate: new Date(),
      addedByUser: 'Arun',
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: 1,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      tagMasterID: -1,
      tagIds: [],
      personaltagIds: [],
      addedByUser: 'Arun',
      attachments: [],
      documentID: -1,
      documentAccessID: null,
      documentAccessName: null,
      sessionID: null,
      linkID: null,
      isSpecialFile: true,
      isUrgent: false,
      isTemp: true,
      description: '',
      uploadedFile: null,
      onBehalfName: '',
      overDueAllowed: 'false',
      followUp: 'false',
      userGroupID: -1,
    },
    defaultData: {
      valid: false,
      taskID: -1,
      date: new Date(),
      title: '',
      assignedTo: [],
      dueDate: new Date(),
      description: '',
      projectID: null,
      assignedCC: [],
      onBehalfID: null,
      sessionID: '',
      addedByUserID: 1,
      addedDate: new Date(),
      addedByUser: 'Arun',
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: 1,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      tagMasterID: -1,
      tagIds: [],
      personaltagIds: [],
      addedByUser: 'Arun',
      attachments: [],
      documentID: -1,
      documentAccessID: null,
      documentAccessName: null,
      sessionID: null,
      linkID: null,
      isSpecialFile: true,
      isUrgent: false,
      isTemp: true,
      description: '',
      uploadedFile: null,
      onBehalfName: '',
      overDueAllowed: 'false',
      followUp: 'false',
      mainTaskId: null,
      userGroupID: -1,
    },

    tagItems: [],
    projectItems: [],
    userItems: [],
    userCCItems: [],
    userToItems: [],
    userGroupItems: [],
    items: [],
    taskItems: [],
    taskItemLink: [],
    allFiles: [],
    uploadedFiles: [],
    editFile: {
      name: '',
      size: '',
      contentType: '',
    },
    height: {
      type: String,
      default: null,
    },
  }),
  computed: {
    computeHeight () {
      return {
        height: this.height || ''
      };
    }
  },
  watch: {
    model (val) {
      if (val.length > 5) {
        this.$nextTick(() => this.model.pop())
      }
    }
  },

  mounted () {

  },
  created () {

    window.getApp.$on('EDIT_SUBTASK', item => {
      this.initialize();
      this.formdata = item
      this.showdownloads = true;
      this.uploadedFiles = [],
        this.parentTaskID = item.parentTaskID;
      this.mainTaskId = item.mainTaskId;
      this.formdata.dueDate = this.formateDate(item.dueDate);
    });
    window.getApp.$on('ADD_SUBTASK', item => {
      console.log(item);

      this.initialize();
      this.formdata.addedByUser = this.$store.state.auth.userName;
      this.formdata.dueDate = this.formateDate(item.dueDate);
      this.parentTaskID = item.taskID;
      this.mainTaskId = item.mainTaskId;
    });
    window.getApp.$on('ADD_MAINSUBTASK', item => {
      this.initialize();
      this.formdata.addedByUser = this.$store.state.auth.userName;
      this.formdata.dueDate = this.formateDate(item.dueDate);
      this.parentTaskID = item.taskID;
      this.mainTaskId = item.mainTaskId;
    });
    window.getApp.$on('SAVE_SUBTASK', taskID => {
      this.parentTaskID = taskID;
      this.savesub();
    });
    window.getApp.$on('SEND_TASKOBJ', objTask => {
      this.assignedCC = objTask.assignedCC;
      this.onBehalfID = objTask.onBehalfID;
      this.maindescription = objTask.description;
      //  for (var prop in objTask.assignedCC) {
      //       this.formdata.assignedCC.push(objTask.assignedCC[prop]);
      //     }      
    });
  },

  methods: {
    formateDate (string) {
      return string ? new Date(string).toISOString().substr(0, 10) : '';
    },
    removeTag (item) {

      const index = this.formdata.tagIds.indexOf(item.tagMasterID)
      if (index >= 0) this.formdata.tagIds.splice(index, 1)
    },
    removeCC (item) {
      const index = this.formdata.assignedCC.indexOf(item.userID)
      if (index >= 0) this.formdata.assignedCC.splice(index, 1)
    },
    removeTo (item) {
      const index = this.formdata.assignedTo.indexOf(item.userID)
      if (index >= 0) this.formdata.assignedTo.splice(index, 1)
    },
    removeStatus (item) {
      this.formdata.statusCodeID = null;
    },
    removeProject (item) {
      //const index = this.projectItems.indexOf(item)
      this.formdata.projectID = null;
    },
    removePTag (item) {
      const index = this.formdata.personaltagIds.indexOf(item)
      if (index >= 0) this.formdata.personaltagIds.splice(index, 1)
    },
    initialize () {
      
      this.formdata.assignedCC = [];
      this.formdata = Object.assign({}, this.defaultData);
      this.formdata.addedByUser = this.$store.state.auth.userName;
      this.loader = true;
      this.formdata.dueDate = new Date().toISOString().substr(0, 10);
      this.formdata.assignedCC = this.assignedCC;
      this.formdata.onBehalfID = this.onBehalfID;
      getApplicationUsers('')
        .then(response1 => {
          this.userItems = response1.data;
          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getUserGroups('')
        .then(response2 => {
          this.userGroupItems = response2.data;

          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getProjects('')
        .then(response2 => {
          this.projectItems = response2.data;
          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

      getTagMaster('')
        .then(response => {
          this.tagItems = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);

        });
      getPersonalTags(-1, this.$store.state.auth.userId)
        .then(response => {
          this.PersonaltagItems = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);

        });

    },
    // getAttachments () {
    //   getTaskAttachment(this.formdata.taskID)
    //     .then(response => {

    //       this.editFile.name = response.data[0].fileName;
    //       this.editFile.contentType = response.data[0].contentType;
    //       this.editFile.size = response.data[0].fileSize;
    //       this.showdownloads = true;

    //       this.uploadedFiles.push(this.editFile);
    //       this.loader = false;

    //     })
    //     .catch(error => {
    //       this.loader = false;
    //       window.getApp.$emit('APP_API_ERROR', error);
    //     });
    // },
    filesubChanged (file) {
      console.log(file);
      this.uploadedFiles.push(file);
      this.showdownloads = false;
      this.loader = true;
      this.taskfiles.append("file", file, file.name);
      uploadDocuments(this.taskfiles)
        .then(response => {
          this.formdata.sessionID = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

    },
    removeFile (key) {
      this.uploadedFiles.splice(key, 1);
    },
    // isImage (file) {
    //   return this.imageMime.includes(file.fileType);
    // },
    // mimeIcons (file) {
    //   return this.imageMime.includes(file.fileType)
    //     ? 'image'
    //     : 'insert_drive_file';
    // },
    // showDetail (file) {
    //   this.editedIndex = this.documents.indexOf(file);
    //   this.editedItem = Object.assign({}, file);

    //   documentUsers(this.editedItem.documentID)
    //     .then(response => {
    //       this.editedItem.userID = response.data;
    //       this.loader = false;
    //     })
    //     .catch(error => {
    //       this.loader = false;
    //       window.getApp.$emit('APP_API_ERROR', error);
    //     });

    //   this.uploadFile = true;
    // },
    // showFiles (item) {
    //   console.log(item);
    //   this.documents = this.allFiles.filter(f => f.departmentID == item.value);
    //   this.view = 'list';
    // },
    downloadFile (key) {

      this.loader = true;
      downloadFile(this.formdata.attachments[key])
        .then(response => {
          let blob = new Blob([response.data], { type: this.editFile.contentType })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = this.editFile.name
          link.click()
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

    },
     userGroupCC (value) {
      this.loader=true;
      getUserById(value)
        .then(response3 => {
          this.userCCItems = response3.data;
         // console.log(this.userCCItems);
          this.formdata.assignedCC=[];
          for(var id in this.userCCItems)
          {
          this.formdata.assignedCC.push(this.userCCItems[id].userID);
          }
          
         // console.log(this.formdata.assignedCC)

          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    userGroupTo (value) {
      this.loader=true;
      getUserById(value)
        .then(response4 => {
          this.userToItems = response4.data;
         this.formdata.assignedTo=[];
          for(var id in this.userToItems)
          {
          this.formdata.assignedTo.push(this.userToItems[id].userID);
          }
          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    savesub () {
      if (this.$refs.validatesubform.validate()) {
        this.loader = true;
        if (this.formdata.taskID > -1) {
          this.formdata.modifiedByUserId = this.$store.state.auth.userId;
          this.formdata.modifiedDate = new Date();
          this.formdata.addedByUserId = this.$store.state.auth.userId;
          this.formdata.addedDate = new Date();
          this.formdata.mainTaskId = this.mainTaskId;
          this.formdata.parentTaskID = this.parentTaskID;
          updateSubTaskMaster(this.formdata)
            .then(response => {
              this.loader = false;
              this.actionButton = true;
              window.getApp.$emit('INITIALIZE_SUBTASK', this.mainTaskId);
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        } else {
          //this.formdata.taskID = parseInt(Math.random() * 100) + 1024; // mock a id
          this.formdata.addedByUserId = this.$store.state.auth.userId;
          this.formdata.addedDate = new Date();
          this.formdata.statusCodeID = 512;
          this.formdata.parentTaskID = this.parentTaskID;
          this.formdata.mainTaskId = this.mainTaskId;
          console.log(this.formdata);

          createSubTaskMaster(this.formdata)
            .then(response => {
              this.loader = false;
              this.formdata = response.data;
              console.log(this.mainTaskId);
              window.getApp.$emit('INITIALIZE_SUBTASK', this.mainTaskId);
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        }
      }
      else {
        window.getApp.$emit('APP_API_VAL', GlobalMessage.VALIDATE);
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.quill {
  height: 250px;
}
</style>


// WEBPACK FOOTER //
// src/pages/task/subtask.vue